import { EventRole } from '@goldcast/api/backend';

import actions from '@/studio/checkInStaff/store/actions';
import getters from '@/studio/checkInStaff/store/getters';
import mutations from '@/studio/checkInStaff/store/mutations';

export interface State {
  checkInStaff: CheckInStaffMap;
  isLoadingCheckInStaff: boolean;
}

/* eslint-disable no-unused-vars */
export const enum Role {
  CHECK_IN_STAFF = 8
}

export type CheckInStaffMap = {
  [id: string]: EventRole;
};

export const getInitialState = () => ({
  checkInStaff: {},
  isLoadingCheckInStaff: false
});

const state: State = getInitialState();

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
